import { formatPenniesToCurrency } from 'src/common/utils/formatPenniesToCurrency';
import {
  IItem,
  ILineItem,
  IParticipantLineMap,
  IReceiptGroupOrderInfo,
  OrderPaymentType,
} from 'src/types/OrderHistory';

export function createItems(lineItems: ILineItem[]): IItem[] {
  return (lineItems || []).map((item) => ({
    quantity: item.quantity,
    name: item.name,
    price: formatPenniesToCurrency(item.price),
  }));
}

export function createParticipantLines(
  isGroupOrder: boolean,
  groupOrderInfo: IReceiptGroupOrderInfo
): IParticipantLineMap[] {
  return isGroupOrder
    ? (groupOrderInfo.participant_lines || []).map((item) => {
        const lineItems = item.order_lines.line_items;
        const participantLineMap: IParticipantLineMap = {
          dinerName: item.diner_info.name,
          dinerId: item.diner_info.id,
          isHost: false,
          items: createItems(lineItems),
        };
        return participantLineMap;
      })
    : [];
}

export function showDinerBorderBottom(
  isHost: boolean,
  participantLinesLength: number,
  idx?: number
): boolean {
  const isLastParticipantLine = participantLinesLength === idx + 1;

  if (isHost && participantLinesLength === 0) {
    return false;
  }

  if (isLastParticipantLine) {
    return false;
  }

  return true;
}

export function getDisplayOrderType({
  isGroupOrder,
  orderType,
}: {
  isGroupOrder: boolean;
  orderType: string;
}): string {
  return isGroupOrder ? 'Group' : orderType;
}

const orderPaymentRewardTypes = [
  OrderPaymentType.REWARD,
  OrderPaymentType.UNIFIED_REWARD,
];

export const orderPaymentTypeIsReward = (type: OrderPaymentType): boolean =>
  orderPaymentRewardTypes.includes(type);
